import React from 'react';
import './CatalogViewTab.css';
import useCatalogManagementStore from '@/stores/AdminStore/CatalogManagementStore';

const CatalogViewTab: React.FC = () => {
  const { catalogCourses } = useCatalogManagementStore();

  return (
    <div className="admin-catalog-view-content">
      <div className="admin-catalog-filters">
        <select className="admin-catalog-filter-select">
          <option>All Categories</option>
          <option>Leadership & Management</option>
          <option>Technical Skills</option>
          <option>Soft Skills</option>
        </select>
        <select className="admin-catalog-filter-select">
          <option>All Levels</option>
          <option>Beginner</option>
          <option>Intermediate</option>
          <option>Advanced</option>
        </select>
        <select className="admin-catalog-filter-select">
          <option>Duration</option>
          <option>1-4 weeks</option>
          <option>5-8 weeks</option>
          <option>9+ weeks</option>
        </select>
      </div>

      <div className="admin-catalog-preview-notice">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <div>
          <strong>Preview Mode</strong>
          <p>This is how learners will see the catalog. Admin-only features are hidden in this view.</p>
        </div>
      </div>

      <div className="admin-catalog-grid">
        {catalogCourses?.map((course) => (
          <div key={course.id} className="admin-catalog-course-card">
            <div className="admin-catalog-course-card-image">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                <path
                  d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2V3zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7V3z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="admin-catalog-course-card-content">
              <h3 className="admin-catalog-course-card-title">{course.title}</h3>
              <p className="admin-catalog-course-card-category">{course.category}</p>
              <div className="admin-catalog-course-card-meta">
                <div className="admin-catalog-course-rating">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFA500">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span>{course.rating}</span>
                </div>
                <span className="admin-catalog-course-duration">{course.duration}</span>
              </div>
              <span className={`admin-catalog-level-badge admin-catalog-${course.level.toLowerCase()}`}>
                {course.level}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CatalogViewTab;
